module.exports = __webpack_public_path__ + "static/media/snowplow.314dcbd8.svg";